export default {
  // Header Section
  "discover_your": "உங்கள்",
  "dasha_phal": "தசா பலன்",
  "planetary_periods_analysis": "கிரக காலங்கள் பகுப்பாய்வு",
  "dasha_phal_description": "உங்கள் விம்‌ஷொட்டரி மகாதசா பயணம், குறிப்பாக சுக்கிரன், சூரியன், சந்திரன், செவ்வாய், ராகு, சனி காலங்களில், வலுவான தொழில் வளர்ச்சி, செல்வம், மரியாதை மற்றும் ஆதரவு உறவுகள் போன்ற கட்டங்களை வெளிப்படுத்துகிறது.",

  // Service Information
  "enter_birth_details": "உங்கள் பிறப்பு விவரங்களை உள்ளிடுங்கள்",
  "complete_dasha_phal_analysis": "முழுமையான தசா பலன் பகுப்பாய்வு",
  "service_price": "சேவை விலை",
  "comprehensive_dasha_analysis_note": "உங்கள் வாழ்க்கையைப் பாதிக்கும் அனைத்து பெரிய மற்றும் சிறிய கிரக காலங்களின் விரிவான பகுப்பாய்வு",

  // Form Fields
  "full_name": "முழுப் பெயர்",
  "enter_full_name": "உங்கள் முழுப் பெயரை உள்ளிடுங்கள்",
  "email_address": "மின்னஞ்சல் முகவரி",
  "enter_email_address": "உங்கள் மின்னஞ்சல் முகவரியை உள்ளிடுங்கள்",
  "phone_number": "தொலைபேசி எண்",
  "enter_phone_number": "உங்கள் தொலைபேசி எண்ணை உள்ளிடுங்கள்",
  "gender": "பாலினம்",
  "male": "ஆண்",
  "female": "பெண்",
  "other": "மற்றவை",
  "date_of_birth": "பிறந்த தேதி",
  "time_of_birth": "பிறந்த நேரம்",
  "exact_time_critical_for_dasha": "துல்லியமான பிறந்த நேரம் தசா கணக்கீடுகளுக்கு மிகவும் முக்கியம்",
  "place_of_birth": "பிறந்த இடம்",
  "place_of_birth_placeholder": "நகரம், மாநிலம், நாடு",
  "preferred_language": "விருப்ப மொழி",
  "english": "ஆங்கிலம்",
  "hindi": "ஹிந்தி",
  "telugu": "தெலுங்கு",
  "kannada": "கன்னடம்",
  "language_note": "உங்கள் பகுப்பாய்வு தேர்ந்தெடுக்கப்பட்ட மொழியில் வழங்கப்படும்",

  // Features & Benefits
  "current_dasha_period_analysis": "தற்போதைய தசா காலப் பகுப்பாய்வு",
  "planetary_influence_detailed": "கிரகங்களின் தாக்கம் — விரிவான பகுப்பு",
  "future_dasha_predictions": "எதிர்கால தசா முன்னறிவிப்புகள்",
  "career_and_finance_guidance": "தொழில் & நிதி வழிகாட்டுதல்",
  "remedial_measures": "பரிகார முறைகள்",
  "pdf_download": "PDF பதிவிறக்கம்",

  "what_you_get": "நீங்கள் பெறுவது",
  "current_mahadasha_antardasha": "தற்போதைய மகாதசா & அந்தர்தசா",
  "planetary_effects_detailed": "கிரக விளைவுகள் — விரிவானவை",
  "timing_of_events": "முக்கிய நிகழ்வுகளின் கால நிர்ணயம்",
  "future_dasha_timeline": "எதிர்கால தசா காலவரிசை",

  // Actions & Buttons
  "pay_and_generate_chart": "கட்டணம் செலுத்தி பகுப்பாய்வு உருவாக்கவும்",
  "processing_payment": "கட்டணம் செயலாக்கப்படுகிறது",
  "processing_request": "கோரிக்கை செயலாக்கப்படுகிறது",

  // Payment & Success Messages
  "thank_you": "நன்றி",
  "payment_successful": "கட்டணம் வெற்றிகரமாக முடிந்தது!",
  "dasha_phal_analysis_processing": "உங்கள் தசா பலன் பகுப்பாய்வு கோரிக்கை பெறப்பட்டு எங்கள் நிபுணர் ஜோதிடர்களால் செயலாக்கப்படுகிறது.",
  "order_id": "ஆர்டர் ஐடி",
  "payment_id": "கட்டணம் ஐடி",
  "amount_paid": "செலுத்திய தொகை",

  // Delivery Information
  "delivery_information": "விநியோக தகவல்",
  "delivery_time": "விநியோக நேரம்",
  "within_12_hours_delivery_note": "உங்கள் பகுப்பாய்வு 12 மணிநேரத்திற்குள் வழங்கப்படும்",
  "whatsapp_notification": "WhatsApp அறிவிப்பு",
  "whatsapp_delivery_note": "WhatsApp-ல் புதுப்பிப்புகள் கிடைக்கும்",
  "email_delivery": "மின்னஞ்சல் விநியோகம்",
  "email_delivery_note": "பகுப்பாய்வு அனுப்பப்படும் முகவரி",

  // What You'll Receive
  "what_youll_receive": "உங்களுக்கு கிடைப்பவை",
  "detailed_dasha_phal_report": "விரிவான தசா பலன் அறிக்கை (PDF)",
  "current_planetary_periods": "தற்போதைய கிரக காலங்களின் பகுப்பாய்வு",
  "future_dasha_predictions_timeline": "எதிர்கால தசா முன்னறிவிப்பு காலவரிசை",
  "planetary_remedies_guidance": "கிரக பரிகாரங்கள் & வழிகாட்டுதல்",
  "career_finance_predictions": "தொழில் & நிதி முன்கணிப்புகள்",

  // Visual Content
  "sample_dasha_phal": "மாதிரி தசா பலன் பகுப்பாய்வு",
  "sample_dasha_phal_description": "உங்கள் விரிவான தசா பலன் பகுப்பாய்வு இவ்வாறு தோன்றும்",
  "major_planetary_periods": "முக்கிய கிரக காலங்கள்",

  // Planetary Periods
  "sun_dasha": "சூரியன் தசா",
  "moon_dasha": "சந்திரன் தசா",
  "mars_dasha": "செவ்வாய் தசா",
  "mercury_dasha": "புதன் தசா",
  "jupiter_dasha": "வியாழன் தசா",
  "venus_dasha": "சுக்கிரன் தசா",

  // Status & Processing
  "your_dasha_phal_analysis_status": "உங்கள் தசா பலன் பகுப்பாய்வு நிலை",
  "processing_your_analysis": "உங்கள் பகுப்பாய்வு செயலாக்கப்படுகிறது",
  "analysis_processing_message": "உங்கள் ஜாதகமும் கிரக காலங்களும் எங்கள் நிபுணர்களால் கவனமாகப் பகுப்பாய்வு செய்யப்படுகின்றன.",
  "request_id": "கோரிக்கை ஐடி",
  "status": "நிலை",
  "processing": "செயலாக்கம்",
  "pending": "நிலுவை",
  "email_notification_sent": "மின்னஞ்சல் அறிவிப்பு அனுப்பப்பட்டது",
  "whatsapp_update_coming": "WhatsApp புதுப்பிப்பு விரைவில்",
  "delivery_within_12_hours": "12 மணிநேரத்திற்குள் விநியோகம்",

  // Support & Contact
  "contact_support": "ஆதரவைத் தொடர்புகொள்ளுங்கள்",
  "need_help": "உதவி வேண்டுமா?",
  "contact_us_at": "எங்களை தொடர்பு கொள்ள",

  // Error Messages
  "please_fill_all_required_fields": "அனைத்து தேவையான புலங்களையும் நிரப்புங்கள்",
  "payment_failed": "கட்டணம் தோல்வியடைந்தது. மீண்டும் முயற்சிக்கவும்.",
  "processing_failed": "செயலாக்கம் தோல்வியடைந்தது. ஆதரவைத் தொடர்புகொள்ளுங்கள்.",

  // Form Validation Messages
  "name_required": "பெயர் அவசியம்",
  "email_required": "மின்னஞ்சல் அவசியம்",
  "phone_required": "தொலைபேசி எண் அவசியம்",
  "date_required": "பிறந்த தேதி அவசியம்",
  "time_required": "பிறந்த நேரம் அவசியம்",
  "place_required": "பிறந்த இடம் அவசியம்"
}
